module.exports = __webpack_public_path__ + "images/category_lp/pc/media6_b1fc919393293e757344d2cccc172df1.jpg";